import { call, put, takeLatest } from 'redux-saga/effects';
import { apiResource, uploadImageApi } from '../services/api';
import reducerConstant from 'common/reducerConstants';
import apiConstant from 'common/apiConstants';
import {
  profileSuccess,
  profileFailed,
  updateProfileSuccess,
  updateProfileFailed,
  generateSignedUrlError,
  updateProfile,
} from '../actions/profileActions';

function* getProfile() {
  try {
    const res = yield call(apiResource.get, apiConstant.profile);
    if (res.success) {
      yield put(
        profileSuccess({
          response: res.data,
        })
      );
    } else {
      yield put(
        profileFailed({
          message: res.data.message,
        })
      );
    }
  } catch (e) {
    yield put(
      profileFailed({
        message: 'Something went wrong',
      })
    );
  }
}

function* updateProfileApi(dObj) {
  try {
    const res = yield call(apiResource.put, apiConstant.profile, dObj.payload);
    if (res.success) {
      yield put(
        updateProfileSuccess({
          response: res.data,
        })
      );
    } else {
      yield put(
        updateProfileFailed({
          message: res.data.message,
          errors: res.data.errors,
        })
      );
    }
  } catch (e) {
    yield put(
      updateProfileFailed({
        message: 'Something went wrong',
      })
    );
  }
}

function* genarateUrl(dObj) {
  const file = dObj.payload.imageObj;
  const payload = dObj.payload;
  try {
    const { name, type } = file;
    const payloadObj = {
      fileName: name,
      mimeType: type,
      objType: 'images',
      sourceDisk: 'media',
    };
    const resImage = yield call(
      apiResource.post,
      apiConstant.generateSignedUrl,
      payloadObj
    );
    if (resImage.success) {
      const dataObj = {
        url: resImage.data.url,
        file,
      };
      const res = yield call(uploadImageApi, dataObj);
      if (res.success) {
        payload['mediaId'] = resImage.data.id;
        delete payload.imageObj;
        yield put(updateProfile(payload));
      } else {
        yield put(
          generateSignedUrlError({
            message: 'Something Went Wrong',
            errors: {
              sourceDisk: ['Something went wrong with Image Upload'],
            },
          })
        );
      }
    } else {
      yield put(
        generateSignedUrlError({
          message: resImage.data.message,
          errors: resImage.data.errors,
        })
      );
    }
  } catch (e) {
    yield put(
      generateSignedUrlError({
        message: 'Something went Wrong',
      })
    );
  }
}

function* regenerateKey() {
  try {
    const res = yield call(apiResource.post, apiConstant.regenerateKey, {});
    if (res.success) {
      yield put(
        profileSuccess({
          response: res.data,
        })
      );
    } else {
      yield put(
        profileFailed({
          message: res.data.message,
        })
      );
    }
  } catch (e) {
    yield put(
      profileFailed({
        message: 'Something went wrong',
      })
    );
  }
}

function* profileSaga() {
  yield takeLatest(reducerConstant.profileRequest, getProfile);
  yield takeLatest(reducerConstant.updateProfile, updateProfileApi);
  yield takeLatest(reducerConstant.generateSignedUrl, genarateUrl);
  yield takeLatest(reducerConstant.regenerateKey, regenerateKey);
}

export default profileSaga;
